import { Button, Flex, Input, Label, Span, Range } from '@fareye/ui'
import { isEmpty, hhmmADoMMMYYYY, FaDownload, formatMs } from '@fareye/utils'
import React from 'react'
import { style } from '../../../style/styled'
import { labelColor } from '../../../utility/colors'
import { tripDetailConstant } from '../../../utility/constants'

interface IStoppageListing {
  data: Array<Object>
  exceptionsData: Array<Object>
  dataLength: number
  onSelect: (id: any) => void
  id: { [key: string]: number }
  downloadCsv: any
  stoppageSlider: any
  currStoppageSlider: any
  setCurrStoppageSlider: any
}

export const StoppageListing = ({
  id,
  data,
  exceptionsData,
  dataLength,
  onSelect,
  downloadCsv,
  stoppageSlider,
  currStoppageSlider,
  setCurrStoppageSlider
}: IStoppageListing) => {
  const [stoppageValue, setStoppageValue] = React.useState(currStoppageSlider)
  const fields = [
    'vehicleNo',
    'startLandmark',
    'endTimestamp',
    'startTimestamp',
    'duration'
  ]
  const dataDownload = (stoppageData: any, fields: string[]) => {
    downloadCsv(
      stoppageData.map((item: any) => {
        return {
          vehicleNo: item.vehicleNo,
          startLandmark:
            item.startLandmark +
            (calculateIsAllowed(item) ? '' : ' (not allowed)'),
          startTimestamp: hhmmADoMMMYYYY(item.startTimestamp),
          endTimestamp: hhmmADoMMMYYYY(item.endTimestamp),
          duration: formatMs(item.duration * 1000)
        }
      }),
      fields
    )
  }

  const calculateIsAllowed = (stoppage: any) => {
    let isAllowed = true
    exceptionsData.forEach((item: any) => {
      if (
        new Date(item.createdAt) >= new Date(stoppage.startTimestamp) &&
        new Date(item.createdAt) <= new Date(stoppage.endTimestamp)
      ) {
        isAllowed = false
      }
    })
    return isAllowed
  }

  React.useEffect(() => {
    setStoppageValue(currStoppageSlider)
  }, [currStoppageSlider])

  return (
    <Flex column p={2}>
      {dataLength > 0 && (
        <Flex p={2} column style={{ overflow: 'hidden' }}>
          <Span color={labelColor.normalText}>
            {tripDetailConstant.stoppage}
          </Span>
          {dataLength > 1 && (
            <Range
              formatLabel={(value: any) => formatMs(value)}
              maxValue={stoppageSlider.max}
              minValue={stoppageSlider.min}
              value={stoppageValue}
              onChange={(value: any) => {
                setStoppageValue(value)
              }}
              onChangeComplete={(value: any) => setCurrStoppageSlider(value)}
            />
          )}
        </Flex>
      )}
      {!isEmpty(data) && (
        <Flex justifyContentFlexEnd p={1}>
          <Button
            disabled={isEmpty(data)}
            variant="s"
            onClick={() => !isEmpty(data) && dataDownload(data, fields)}
          >
            <FaDownload style={style.downloadIcon} />
            Download as CSV
          </Button>
        </Flex>
      )}
      {!isEmpty(data) && (
        <Flex justifyContentSpaceAround style={{ paddingBottom: 10 }}>
          <Span color={labelColor.normalText} style={{ width: 23 }} />
          <Span color={labelColor.normalText} style={{ flex: 1 }}>
            {tripDetailConstant.landmark}
          </Span>
          <Span color={labelColor.normalText} style={{ width: 123 }}>
            {tripDetailConstant.startend}
          </Span>
          <Span color={labelColor.normalText} style={{ width: 100 }}>
            {tripDetailConstant.duration}
          </Span>
        </Flex>
      )}

      {!isEmpty(data) ? (
        data
          .sort((a: any, b: any) => b.duration - a.duration)
          .map((item: any, index: number) => (
            <Flex
              key={index}
              justifyContentSpaceBetween
              style={{ marginBottom: '20px' }}
            >
              <Input
                type="radio"
                checked={item.id === id.stoppageId}
                onChange={() => {
                  onSelect({ stoppageId: item.id })
                }}
              />
              <Span
                style={{ flex: 1 }}
                dangerouslySetInnerHTML={{
                  __html:
                    item &&
                    item.startLandmark &&
                    item.startLandmark.split('/').join('<br/>') +
                      (calculateIsAllowed(item)
                        ? ''
                        : '<br/>' + '(not allowed)')
                }}
              />
              <Flex column p={2} style={{ width: '115px' }}>
                <Span>{hhmmADoMMMYYYY(item.startTimestamp)}</Span>
                <Span>{hhmmADoMMMYYYY(item.endTimestamp)}</Span>
              </Flex>
              <Flex
                p={2}
                style={{ width: '90px' }}
                justifyContentSpaceAround
                column
              >
                <Span>{formatMs(item.duration * 1000)}</Span>
              </Flex>
            </Flex>
          ))
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          No Data
        </Label>
      )}
    </Flex>
  )
}
